function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKabab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 11.199219 24 C 11.199219 27.039062 8.738281 29.5 5.699219 29.5 C 2.664062 29.5 0.199219 27.039062 0.199219 24 C 0.199219 20.960938 2.664062 18.5 5.699219 18.5 C 8.738281 18.5 11.199219 20.960938 11.199219 24 Z M 11.199219 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 29.5 24 C 29.5 27.039062 27.039062 29.5 24 29.5 C 20.960938 29.5 18.5 27.039062 18.5 24 C 18.5 20.960938 20.960938 18.5 24 18.5 C 27.039062 18.5 29.5 20.960938 29.5 24 Z M 29.5 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 47.800781 24 C 47.800781 27.039062 45.335938 29.5 42.300781 29.5 C 39.261719 29.5 36.800781 27.039062 36.800781 24 C 36.800781 20.960938 39.261719 18.5 42.300781 18.5 C 45.335938 18.5 47.800781 20.960938 47.800781 24 Z M 47.800781 24 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKabab);
export default __webpack_public_path__ + "static/media/kabab.505e1861db16ae54865b1376463c1993.svg";
export { ForwardRef as ReactComponent };